// ---------------------------------------------------------------------------
// Route matching for guide steps.
//
// A step route may carry query params, because several admin screens are really
// one route with a tab selector - Settings is `/admin/settings?section=X&child=Y`.
// A step is "on route" when the pathname matches exactly and every query param
// the step asked for is present with that value. Extra params already in the URL
// are ignored, so arriving with a stray `?from=email` does not restart the step.
//
// Trailing slashes are ignored on both sides. Some route definitions carry one
// and the matching PATH_ADMIN constant does not, and a guide should never hang
// on that difference.
// ---------------------------------------------------------------------------

// '/admin/x/' and '/admin/x' are the same page. '/' stays '/'.
function trimSlash(pathname) {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

export function splitRoute(route) {
  if (!route) return { pathname: null, params: {} };
  const [pathname, search = ''] = String(route).split('?');
  const params = {};
  new URLSearchParams(search).forEach((value, key) => {
    params[key] = value;
  });
  return { pathname, params };
}

export function routeMatches(route, location) {
  const { pathname, params } = splitRoute(route);
  if (!pathname) return true; // step is route-agnostic
  if (trimSlash(location.pathname || '') !== trimSlash(pathname)) return false;

  const current = new URLSearchParams(location.search || '');
  return Object.entries(params).every(([key, value]) => current.get(key) === value);
}
